
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/[profileSection]",
      function () {
        return require("private-next-pages/[slug]/[profileSection].tsx");
      }
    ]);
  